import React, { CSSProperties } from 'react';
import 'twin.macro';
import { AnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ITreeNode, TreeEventHandler } from './types';
import { TreeItem } from 'components/Tree2/TreeItem';

const animateLayoutChanges: AnimateLayoutChanges = ({
  isSorting,
  wasDragging,
}) => (isSorting || wasDragging ? false : true);

interface Props<T> {
  id: string;
  node?: ITreeNode<T>;
  onNodeClick: TreeEventHandler<T>;
  onNodeCollapse?: TreeEventHandler<T>;
  onNodeExpand?: TreeEventHandler<T>;
  path: number[];
  index: number;
  isDragging?: boolean;
  isPlaceholder?: boolean;
  draggingItem?: ITreeNode<T>;
  RenderLabelComponent?: React.ComponentType<{ node: ITreeNode<T> }>;
}

export function SortableTreeItem<T>(props: Props<T>) {
  const { id, node, isPlaceholder, draggingItem } = props;

  const {
    attributes,
    listeners,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
    isSorting,
  } = useSortable({
    id,
    animateLayoutChanges,
  });
  const style: CSSProperties = {
    // transform: CSS.Translate.toString(transform),
    transform: isSorting ? undefined : CSS.Translate.toString(transform),
    transition,
  };
  if (!node) return null;

  const isDisabledOver = () =>
    node?.isDisabledOver ? node?.isDisabledOver(draggingItem?.nodeData) : false;
  return (
    <TreeItem
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      style={style}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      isOver={isOver && !isDisabledOver()}
      isPlaceholder={isPlaceholder}
      isDraggingItem={isDragging}
      {...props}
    />
  );
}
